module.exports = __webpack_public_path__ + "static/media/icon-freeze.f3885c23.svg";